var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dots-icon-container d-flex flex-column align-items-center align-content-center justify-content-center flex-shrink-0",style:({width: _vm.size+'px', height: _vm.size+'px'})},_vm._l(([1,2,3]),function(dot){return _c('div',{key:dot,staticClass:"dot",style:({backgroundColor: _vm.color})})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }